import React from 'react';

import {
  FromIdeaToLiveCommunityContainer,
  FromIdeaToLiveCommunityContent,
  FromIdeaToLiveCommunityText,
} from './FromIdeaToLiveCommunityStatic.styles';
import Heading from 'src/elements/typography/heading';
import Paragraph from 'src/elements/typography/paragraph';
import FromIdeaImageSlide from 'src/molecules/Standard/Homepage/2024_Q1_people_magic/FromIdeaImageSlide/FromIdeaImageSlide';
import FromIdeaToLiveIdealMember from 'src/molecules/Standard/Homepage/2024_Q1_people_magic/FromIdeaToLiveIdealMember/FromIdeaToLiveIdealMember';

const FromIdeaToLiveCommunityStatic = (): JSX.Element => {
  return (
    <FromIdeaToLiveCommunityContainer>
      <FromIdeaToLiveCommunityContent>
        <FromIdeaToLiveCommunityText>
          <Heading
            standardSize='3.375'
            weight={700}
            text='From idea to live community in less than 60 seconds'
          />
          <Paragraph
            className='desktop-description'
            standardSize='1.5'
            text='Don’t start with a blank page. From one question, Mighty Co-Host™ will build out your pitch, landing page, and a simple community to get you started.'
          />
          <Paragraph
            className='mobile-description'
            standardSize='1.5'
            text='Mighty Co-Host™ will build out your pitch, landing page, and a simple community to get you started. All you have to do is answer ONE question.'
          />
          <FromIdeaToLiveIdealMember />
        </FromIdeaToLiveCommunityText>
        <FromIdeaImageSlide />
      </FromIdeaToLiveCommunityContent>
    </FromIdeaToLiveCommunityContainer>
  );
};

export default FromIdeaToLiveCommunityStatic;
